export default "__VITE_ASSET__qcAf_Vw2__"